import { useLayoutEffect } from "react";

const savedScrollTops = new Map<string, number>();

/**
 * Preserves a scroll container's `scrollTop` across unmounts, keyed by `key`.
 *
 * Takes a `selector` instead of a ref for containers we don't own the markup for,
 * e.g. the item list inside Beam's `SideNav`.
 */
export function useScrollRestore(key: string, selector: string) {
  useLayoutEffect(() => {
    const el = document.querySelector<HTMLElement>(selector);
    if (!el) return;

    const saved = savedScrollTops.get(key);
    if (saved) el.scrollTop = saved;

    // A collapsed or empty list isn't scrollable and would overwrite the saved offset with 0.
    const onScroll = () => {
      if (el.scrollHeight > el.clientHeight) savedScrollTops.set(key, el.scrollTop);
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [key, selector]);
}
